import React from 'react';
import { HStack } from '../../Stack';
import { LabelText } from '../../Text';
import { theme } from '@garnish/constants';
import { StyleSheet, View } from 'react-native';

export const HorizontalScrollRailCount = ({
  count,
}: HorizontalScrollRailCountProps) => {
  if (count === 0) return null;

  return (
    <HStack
      customSpacing={theme.spacing.xsmall}
      shouldFillAvailableSpace={false}
    >
      <HorizontalScrollRailCountText count={count} />
    </HStack>
  );
};

const HorizontalScrollRailCountText = ({
  count,
}: HorizontalScrollRailCountProps) => {
  return (
    <View style={styles.countContainer}>
      <LabelText size={1}>{count}</LabelText>
    </View>
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type HorizontalScrollRailCountProps = {
  readonly count: number;
};

// ─── STYLES ──────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  countContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 28,
    borderWidth: 1,
    width: 28,
    height: 28,
    borderColor: theme.colors.BLACK,
  },
});
